import createIcon from '../../createIcon';

/**
 * @component @name ChangeHistory
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNy43N0wxOC4zOSAxOEg1LjYxTDEyIDcuNzdaTTEyIDRMMiAyMEgyMkwxMiA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChangeHistory = createIcon('ChangeHistory', [
  ['path', { d: 'M12 7.77L18.39 18H5.61L12 7.77ZM12 4L2 20H22L12 4Z', key: '197ohr' }],
]);

export default ChangeHistory;
